var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("h3", [_vm._v("插件介绍")]),
      _vm._v(" "),
      _c("p", [_vm._v("Tooltip， 提示框。")]),
      _vm._v(" "),
      _c("h3", [_vm._v("attrs")]),
      _vm._v(" "),
      _c("table", [
        _c("thead", [
          _c("tr", [
            _c("th", [_vm._v("属性名")]),
            _vm._v(" "),
            _c("th", [_vm._v("类型")]),
            _vm._v(" "),
            _c("th", [_vm._v("默认值")]),
            _vm._v(" "),
            _c("th", [_vm._v("描述")])
          ])
        ]),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("td", [_vm._v("title")]),
            _vm._v(" "),
            _c("td", [_vm._v("String | Function")]),
            _vm._v(" "),
            _c("td", [_c("code", { pre: true }, [_vm._v("null")])]),
            _vm._v(" "),
            _c("td", [_vm._v("标题")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("formatter")]),
            _vm._v(" "),
            _c("td", [_vm._v("Function")]),
            _vm._v(" "),
            _c("td", [_c("code", { pre: true }, [_vm._v("d => d")])]),
            _vm._v(" "),
            _c("td", [_vm._v("除标题外，其他文本格式化函数")])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("style")]),
      _vm._v(" "),
      _c("pre", { pre: true }, [
        _c(
          "code",
          { pre: true, attrs: { "v-pre": "", class: "language-javascript" } },
          [
            _c("span", { pre: true, attrs: { class: "hljs-keyword" } }, [
              _vm._v("const")
            ]),
            _vm._v(" tooltip = "),
            _c("span", { pre: true, attrs: { class: "hljs-keyword" } }, [
              _vm._v("new")
            ]),
            _vm._v(" Tooltip()\ntooltip.style("),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v("'text'")
            ]),
            _vm._v(", { "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("color")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v("'#fff'")
            ]),
            _vm._v(" }\n")
          ]
        )
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("组件中可以自定义 css 属性的元素如下表：")]),
      _vm._v(" "),
      _c("table", [
        _c("thead", [
          _c("tr", [
            _c("th", [_vm._v("名称")]),
            _vm._v(" "),
            _c("th", [_vm._v("基础类型")]),
            _vm._v(" "),
            _c("th", [_vm._v("描述")])
          ])
        ]),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("td", [_vm._v("title")]),
            _vm._v(" "),
            _c("td", [_vm._v("文本")]),
            _vm._v(" "),
            _c("td", [_vm._v("html 文本样式")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("point")]),
            _vm._v(" "),
            _c("td", [_vm._v("html 容器")]),
            _vm._v(" "),
            _c("td", [_vm._v("html 容器样式")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("text")]),
            _vm._v(" "),
            _c("td", [_vm._v("文本")]),
            _vm._v(" "),
            _c("td", [_vm._v("html 文本样式")])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }